<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/leiloes/services'
  import relatorioService from '../../../../domain/relatorios/services'
  import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'
  import RelatorioLoading from './_RelatorioLoading'

  var ASCIIList = 'àÀáÁâÂãÃäåéÉíÍóÓúÚãÃçÇêÊõÕôÔ'

  function ToASCII (string) {
    var _str = string
    ASCIIList.split('').map((v) => {
      var regex = new RegExp(v, 'g')
      _str = _str.replace(regex, '&#' + v.charCodeAt(0) + ';')
    })
    return _str
  }

  export default {
    components: {RelatorioLoading},
    nome: 'relatorio-leilao-lances-comitente',
    directives: {mask},
    data () {
      let situacaoLote = [
        {label: 'Vendidos', value: 6, class: 'btn-default'}, /*,  class: 'btn-info' */
        {label: 'Condicionais', value: 7, class: 'btn-default'}, /*,  class: 'btn-primary' */
        {label: 'Sem licitantes', value: 8, class: 'btn-default'}, /* , class: 'btn-success' */
        {label: 'Baixa Oferta', value: 9, class: 'btn-default'}, /* , class: 'btn-success' */
        {label: 'Retirados', value: 10, class: 'btn-default'} /* , class: 'btn-success' */
      ]
      return {
        isLoading: false,
        leilao: null,
        tiposLeilao: [
          {label: 'Qualquer', value: '', class: 'btn-default'},
          {label: 'Online', value: 2, class: 'btn-default'},
          {label: 'Presencial', value: 1, class: 'btn-default'}
        ],
        situacaoLote: situacaoLote,
        filterKey: '',
        sortKey: '',
        filtro: {
          comitente: null,
          grupoComitente: null,
          tipo: '',
          situacao: situacaoLote.map(a => a.value)
        },
        sortOrders: {
          'numero': 1,
          'titulo': 1,
          'comitente': 1
        },
        showFiltros: true,
        comitentes: null,
        gruposComitentes: null,
        comitentesParticipantes: []
      }
    },
    computed: {
      filteredComitentes: function () {
        let data = this.comitentes
        let comitentesParticipantes = this.comitentesParticipantes
        data = data.filter(row => comitentesParticipantes.includes(row.id))
        return data
      },
      filteredData: function () {
        let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let filtrosFixos = this.filtro
        let order = this.sortOrders[sortKey] || 1
        let data = this.leilao.lotes
        // let tipo = this.filtro.tipo
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }

        // Situação
        let comitentesParticipantes = this.comitentesParticipantes
        data = data.filter(function (row) {
          if (!comitentesParticipantes.includes(row.comitente.id)) {
            comitentesParticipantes.push(row.comitente.id)
          }
          return filtrosFixos.situacao.some(el => el === row.status)
        })

        // Tipo
        if (filtrosFixos.tipo) {
          data = data.filter(function (row) {
            if (!row.arremate) {
              return false // Não foi arrematado
            }
            let test
            if (filtrosFixos.tipo === 2) { // Online
              test = row.arremate.arrematante.apelido !== 'PLATEIA'
            } else if (filtrosFixos.tipo === 1) { // Presencial
              test = row.arremate.arrematante.apelido === 'PLATEIA'
            } else {
              test = true
            }
            return test
          })
        }

        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }

        // comitente
        if (filtrosFixos.comitente) {
          data = data.filter(function (row) {
            return parseInt(row.comitente.id) === parseInt(filtrosFixos.comitente)
          })
        }

        // grupo comitente
        if (filtrosFixos.grupoComitente) {
          data = data.filter(function (row) {
            if (row.comitente.grupo === null || typeof row.comitente.grupo['id'] === 'undefined') {
              return false
            }
            return parseInt(row.comitente.grupo.id) === parseInt(filtrosFixos.grupoComitente)
          })
        }
        return data
      },
      getStatus () {
        return Status.Status
      },
      Status () {
        return Status
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.isLoading = true
      relatorioService.comitentes()
        .then((response) => {
          this.comitentes = response.data.comitentes
          relatorioService.gruposComitentes()
            .then((response) => {
              this.gruposComitentes = response.data.grupos
            })
            .catch((response) => {
              console.log(response)
            })
        })
        .catch((response) => {
          console.log(response)
        })
      service.getLeilaoLances(this.$route.params.id)
        .then((response) => {
          this.isLoading = false
          this.leilao = response.data
        })
        .catch((response) => {
          this.isLoading = false
          console.log(response)
        })
    },
    deactivated () {
    },
    watch: {
      'filtro.grupoComitente': function (v) {
        if (v !== null) {
          this.filtro.comitente = null
        }
      }
    },
    methods: {
      primeiroNome (n) {
        let nome = String(n).split(' ').shift()
        return nome.toLowerCase() === 'arrematante' ? '-' : nome
      },
      fnExcelReport () {
        /* eslint-disable */
        console.log(this.$refs.table)
        var tab_text = "<table border='2px'><tr style='color:#FFFFFF' bgcolor='#FF0000'>";
        var textRange;
        var j = 0;
        var tab = this.$refs.table; // id of table
        var sa

        for (j = 0; j < tab.rows.length; j++) {
          tab_text = tab_text + ToASCII(tab.rows[j].innerHTML) + "</tr>";
          //tab_text=tab_text+"</tr>";
        }

        tab_text = tab_text + "</table>";
        tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
        tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
        tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer
        {
          txtArea1.document.open("txt/html", "replace");
          txtArea1.document.write(tab_text);
          txtArea1.document.close();
          txtArea1.focus();
          sa = txtArea1.document.execCommand("SaveAs", true, "Lances.xls");
        } else                 //other browser not tested on IE 11
          sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));

        return (sa);
      }
    }
  }
</script>

<template>
  <div class="r-container" :class="{'is-loading': isLoading}">
    <iframe id="txtArea1" style="display:none"></iframe>
    <relatorio-loading v-if="isLoading"></relatorio-loading>
    <transition name="slide">
      <div v-if="!isLoading" class="content-transition relatorio-print" id="container-printer">

        <div class="hidden-print">
          <div class="text-center m-t m-b-n">
            <h3 @click="showFiltros = !showFiltros" class="btn m-t-none"><span class="btn btn-default btn-xs m-r-xs">{{ !showFiltros ? '+' : '-' }}</span>Filtros
            </h3>
          </div>
          <div class="r-table" v-show="showFiltros">
            <div class="r-table-content">
              <div class="m-t">
                <!--<div class="m-b">
                  <div>Tipo de Lance:</div>
                  <u-button-group v-model="filtro.tipo" :options="tiposLeilao"></u-button-group>
                </div>-->
                <div class="m-b">
                  <div>Comitente:</div>
                  <select v-if="comitentes" :disabled="filtro.grupoComitente !== null" v-model="filtro.comitente">
                    <option :value="null">Todos</option>
                    <option v-for="comitente in filteredComitentes" :value="comitente.id">{{comitente.nome}}</option>
                  </select>
                </div>
                <div class="m-b">
                  <div>Grupo de Comitentes:</div>
                  <select v-if="gruposComitentes" v-model="filtro.grupoComitente">
                    <option :value="null">Nenhum</option>
                    <option v-for="grupo in gruposComitentes" :value="grupo.id">{{grupo.nome}}</option>
                  </select>
                </div>
                <div class="m-b">
                  Resultados: {{ filteredData && filteredData.length }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hidden-print">
          <h2 class="text-center text-uppercase font-bold m-b-none">Relatório de Lances</h2>
          <h4 class="text-center text-uppercase">Leilão Realizado {{ moment(leilao.dataAbertura.date).format('LLLL')
            }}</h4>
          <div class="m-b text-center">
            <a class="btn btn-default" @click="fnExcelReport"><i class="fa fa-file-excel-o"></i> Exportar para Excel</a>
          </div>
        </div>
        <div class="printer-page pos-rlt">
          <div class="r-table">
            <!--<div class="r-table-header">
              <div class="pull-left font-bold text-black">{{ lote.titulo }}</div>
              <div class="pull-right font-bold"><h3 class="m-t-none">Lote {{ lote.numero }}</h3></div>
              <div class="clearfix"></div>
            </div>-->
            <div class="r-table-content">

              <table ref="table" class="table table-bordered r-table-min text-uppercase">
                <thead>
                <tr>
                  <th>Lote</th>
                  <th>Login</th>
                  <th style="white-space: nowrap">Primeiro Nome</th>
                  <th>Data do Lance</th>
                  <th>Hora do Lance</th>
                  <th>Valor do Lance</th>
                  <th>Modalidade do Lance</th>
                </tr>
                </thead>
                <tbody v-for="lote in filteredData">
                <tr v-for="lance in lote.lances">
                  <td>
                    {{lote.numero}}
                  </td>
                  <td>
                    {{ lance.arrematante.apelido }}
                  </td>
                  <td>{{ primeiroNome(lance.arrematante.pessoa.nome) }}</td>
                  <td>{{ moment(lance.data.date).format('L') }}</td>
                  <td>{{ moment(lance.data.date).format('LTS') }}</td>
                  <td>{{ lance.valor | moeda }}</td>
                  <td>{{lance.arrematante.apelido !== 'PLATEIA' ? 'Online' : 'Presencial'}}</td>
                </tr>
                <!--<tr v-if="!lote.lances || lote.lances.length === 0">
                  <td colspan="3" class="no-borders" style="border-bottom: none"><span class="text-danger">Nenhum lance</span></td>
                </tr>-->
                </tbody>
              </table>

            </div>
          </div>
          <!--<div class="p-page-numer visible-print">Página {{key+1}} de {{filteredData && filteredData.length}}</div>-->
        </div>
      </div>
    </transition>
  </div>
</template>



// WEBPACK FOOTER //
// RelatorioLancesComitente.vue?5f46404e